/* CUSTOM_AD_VISITOR_BY_CLAUDE — UTM detection + ad visitor web components */

(function () {
  const SESSION_KEY = 'bsf_ad_visitor';
  const DISMISS_KEY = 'bsf_ad_banner_dismissed';

  /**
   * Detect ad visitor via UTM params, persist to sessionStorage,
   * and strip UTM params from URL.
   */
  function detectAdVisitor() {
    const params = new URLSearchParams(window.location.search);
    if (params.get('utm_source') === 'google' && params.get('utm_medium') === 'cpc') {
      sessionStorage.setItem(SESSION_KEY, '1');
      params.delete('utm_source');
      params.delete('utm_medium');
      params.delete('utm_campaign');
      params.delete('utm_term');
      params.delete('utm_content');
      var clean = params.toString();
      var cleanUrl = window.location.pathname + (clean ? '?' + clean : '') + window.location.hash;
      history.replaceState(null, '', cleanUrl);
    }
    return sessionStorage.getItem(SESSION_KEY) === '1';
  }

  var isAdVisitor = detectAdVisitor();

  /* ============================================
     Sticky bottom banner (global, all pages)
     ============================================ */

  if (!customElements.get('ad-visitor-banner')) {
    class AdVisitorBanner extends HTMLElement {
      connectedCallback() {
        if (!isAdVisitor || sessionStorage.getItem(DISMISS_KEY) === '1') return;

        if (window.matchMedia('(min-width: 769px)').matches && document.querySelector('ad-visitor-cta')) {
          return;
        }

        this.classList.add('is-visible');
        this.setAttribute('aria-hidden', 'false');
        this.removeAttribute('inert'); // CUSTOM_COLLECTIONSBOT_BY_CLAUDE — paired with dismiss()

        var dismissBtn = this.querySelector('.ad-visitor-banner__dismiss');
        if (dismissBtn) {
          dismissBtn.addEventListener('click', this.dismiss.bind(this));
        }
      }

      dismiss() {
        sessionStorage.setItem(DISMISS_KEY, '1');
        this.classList.remove('is-visible');
        this.setAttribute('aria-hidden', 'true');
        this.setAttribute('inert', ''); // CUSTOM_COLLECTIONSBOT_BY_CLAUDE — paired with connectedCallback()
      }
    }

    customElements.define('ad-visitor-banner', AdVisitorBanner);
  }

  /* ============================================
     Collection page CTAs (samples + quote)
     ============================================ */

  if (!customElements.get('ad-visitor-cta')) {
    class AdVisitorCta extends HTMLElement {
      connectedCallback() {
        /* CUSTOM_ECORE_BY_CLAUDE — Removed UTM gate; in-page CTA shows for all visitors on collections that include this section. The bottom sticky banner above remains UTM-gated. */
        this.style.display = '';
        this.classList.add('is-visible');

        if (window.matchMedia('(min-width: 769px)').matches) {
          this.initSticky();
        }
      }

      initSticky() {
        this.sentinel = document.createElement('div');
        this.sentinel.style.height = '1px';
        this.sentinel.style.visibility = 'hidden';
        this.sentinel.style.pointerEvents = 'none';
        this.parentElement.insertBefore(this.sentinel, this);

        this.placeholder = document.createElement('div');
        this.placeholder.style.display = 'none';
        this.after(this.placeholder);

        this.header = document.querySelector('.cc-header--sticky') || document.querySelector('header');
        this.isFixed = false;
        this.rafId = null;

        var self = this;
        var onScroll = function () {
          var headerBottom = self.header.getBoundingClientRect().bottom;
          var sentinelTop = self.sentinel.getBoundingClientRect().top;

          if (sentinelTop <= headerBottom && !self.isFixed) {
            self.placeholder.style.height = self.offsetHeight + 'px';
            self.placeholder.style.display = 'block';
            self.classList.add('is-fixed');
            self.style.top = headerBottom + 'px';
            self.isFixed = true;
          } else if (sentinelTop > headerBottom && self.isFixed) {
            self.classList.remove('is-fixed');
            self.style.top = '';
            self.placeholder.style.display = 'none';
            self.isFixed = false;
          } else if (self.isFixed) {
            self.style.top = headerBottom + 'px';
          }
        };

        this.scrollListener = function () {
          if (self.rafId) return;
          self.rafId = requestAnimationFrame(function () {
            onScroll();
            self.rafId = null;
          });
        };

        window.addEventListener('scroll', this.scrollListener, { passive: true });
        onScroll();
      }

      disconnectedCallback() {
        if (this.scrollListener) {
          window.removeEventListener('scroll', this.scrollListener);
        }
      }
    }

    customElements.define('ad-visitor-cta', AdVisitorCta);
  }
})();

/* END CUSTOM_AD_VISITOR_BY_CLAUDE */
